import { ExplorerLink, TokenHistoryOperation, TraderHistoryOperation } from '@archax/shared-types'
import { Link } from '@mui/material'
import { getExplorerLogo } from '../../../constants'

export interface ExplorerLinksProps {
  operation: TokenHistoryOperation | TraderHistoryOperation
}

const ExplorerLinks: React.FunctionComponent<ExplorerLinksProps> = ({ operation: { explorerLinks, token } }) => {
  return (
    <>
      {explorerLinks?.map((explorerLink: ExplorerLink, index: number) => (
        <Link
          key={index}
          href={explorerLink.url}
          rel="noreferrer"
          target="_blank"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0',
          }}
        >
          <img
            alt={explorerLink.value}
            src={getExplorerLogo(token!.standard.chain.protocol, token!.privacyEnabled)}
            width="18"
          />
        </Link>
      ))}
    </>
  )
}

export default ExplorerLinks
